<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('add_payment_note') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-6.pt-6.pb-10
      .d-flex
        .text-sm.font-semibold.neutral500--text.flex-grow-1 {{ $t('add_payment_note') }}
        .text-xs.font-semibold.underline.mb-1.clickable(@click="clearNote") Clear note
      v-textarea.text-sm.mt-2.round-xl(v-model="paymentNote" placeholder="Enter note" outlined hide-details="auto" height=80)

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" color="primary" depressed) {{ $t('save') }}

</template>

<script>
export default {
  name: 'PaymentNoteDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: null
    }
  },
  data: () => ({
    paymentNote: null
  }),
  computed: {
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.paymentNote = this.note
  },
  methods: {
    clearNote () {
      this.paymentNote = ''
    },
    save () {
      this.showDialog = false
      this.$emit('onSaved', this.paymentNote)
    }
  }
}
</script>
